/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState, useRef } from "react";
import { getArticuloData } from "../../services/ArticuloService";
import DatosAccesorio from "../consulta-articulo/DatosAccesorio.jsx";
import DatosArmazon from "../consulta-articulo/DatosArmazon.jsx";
import DatosAnteojoSol from "../consulta-articulo/DatosAnteojoSol.jsx";
import DatosFornitura from "../consulta-articulo/DatosFornitura.jsx";
import DatosLenteContacto from "../consulta-articulo/DatosLenteContacto.jsx";
import DatosSolucionLimpieza from "../consulta-articulo/DatosSolucionLimpieza.jsx";
import WaitingDialog from "../../utils/WaitingDialog";

const initialEnvioArticuloItem = {
  id: "",
  id_articulo: "",
  codigoArticulo: "",
  descripcionArticulo: "",
  cantidad: 0,
};

//
// ########################################################################### 
//
const RecepcionArticuloDialog = ({
  envioArticuloItem,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [envioArticuloItemLocal, setEnvioArticuloItemLocal] = useState(initialEnvioArticuloItem);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [tipoArticulo, setTipoArticulo] = useState("");
  const [articuloData, setArticuloData] = useState({});
  const [codigoArticuloDisabled, setCodigoArticuloDisabled] = useState(false);
  //
  // ################################################################################ 
  //
  useEffect(() => {

    setEnvioArticuloItemLocal({
      ...envioArticuloItemLocal,
      id: envioArticuloItem.id ?? "",
      id_articulo: envioArticuloItem.id_articulo ?? "",
      codigoArticulo: envioArticuloItem.codigo_articulo ?? "",
      descripcionArticulo: envioArticuloItem.descripcion_articulo ?? "",
      cantidad: envioArticuloItem.cantidad ?? 0,
    });

    loadArticulo(envioArticuloItem.codigo_articulo);
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################ 
  //
  const loadArticulo = async (parCodigoArticulo) => {

    loadArticuloData(parCodigoArticulo);
  };
  //
  // ################################################################################
  //
  const loadArticuloData = async (parCodigoArticulo) => {

    let _params = {
      codigo: parCodigoArticulo,
    };

    setIsDoingSomething(true);
    const response = await getArticuloData(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setArticuloData(response.data.data[0]);
      setTipoArticulo(response.data.data[0].tipo_articulo);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="lg"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Ver Artículo recibido
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={2} lg={2}>
              <TextField
                sx={{ width: "100%" }}
                id="codigoArticulo"
                label="Código de Artículo"
                size="small"
                inputProps={{
                  autoComplete: "off",
                }}
                name="codigoArticulo"
                value={envioArticuloItemLocal.codigoArticulo ?? ""}
                variant="outlined"
              />
            </Grid>

            {tipoArticulo === "" && (
              <Grid item xs={12} sx={{ mr: 1, mb: 1 }}>
                <Card>
                  <CardContent>
                    <Typography variant="body2" color="text.secondary">
                      ...
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}

            {tipoArticulo === "accesorio" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosAccesorio articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "armazon" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosArmazon articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "anteojo-sol" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosAnteojoSol articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "fornitura" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosFornitura articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "lente-contacto" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosLenteContacto articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            {tipoArticulo === "solucion-limpieza" && (
              <>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  <DatosSolucionLimpieza articulo={articuloData} showPrecio={false} />
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={12} md={2} lg={2}>
              <Box sx={{ width: "100%", mb: 1 }}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                  id="cantidad"
                  label="Cantidad"
                  variant="outlined"
                  size="small"
                  name="cantidad"
                  value={envioArticuloItemLocal.cantidad}
                />
              </Box>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
            >
              <Button
                variant="outlined"
                size="small"
                onClick={handleCloseDialog}
              >
                Cerrar
              </Button>
            </Box>
          </Grid>
        </DialogContent >
      </Dialog >

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default RecepcionArticuloDialog;